export default __webpack_public_path__ + "static/media/794.909d5070.jpg";